import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-global-managed-services',
  templateUrl: './global-managed-services.component.html',
  styleUrls: ['./global-managed-services.component.scss']
})
export class GlobalManagedServicesComponent implements OnInit {
 public serviceNameList :any=[];
 public serviceName=''
  constructor(private router:Router,private service:ApifirstService) { }

  ngOnInit(): void {
   
    this.service.getServiceList().subscribe(data => {
      this.serviceNameList =data;
      console.log(this.serviceNameList,"servoice")
     
    })
  }
  showRules(seriveName:string,id:number){
    this.service.serviceName.next(seriveName);
    this.service.globalServicesId.next(id);
  this.router.navigate(['admin/showRules']);
  }

}
